import api from '../../api/api.js'
import shopaccess from '../../api/moudles/shopaccess.js'

import {
  SET_PICKING_LIST
  

} from '../mutation-types'

const state = () => ({
	picklist:[]
})

const getters = {}

const actions = {

}

const mutations = {
[SET_PICKING_LIST]: (state,data) =>{
	
		state.picklist.push(data)
		console.log('拣货',state.picklist)
	},
	
	

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}